import React from "react";
import { cn } from "../../lib/cn";

export type StatusState = "pre" | "rec" | "mas" | "fin" | "pub" | "done";

export const STATUS_LABELS: Record<StatusState, string> = {
  pre: "Pre-production",
  rec: "Recording",
  mas: "Mastering",
  fin: "Final",
  pub: "Published",
  done: "Done",
};

export interface StatusPillProps {
  state: StatusState;
  /** Overrides the default label for `state`. */
  label?: string;
  className?: string;
}

/** claudesign status chip (dot + tint + border, 6 OKLCH hues).
 *  Mirrors `.st` / `.st-*` from docs/redesign/hub-redesign.css (in src/tailwind.css). */
export const StatusPill: React.FC<StatusPillProps> = ({ state, label, className }) => (
  <span className={cn("st", `st-${state}`, "font-sans", className)}>
    <span className="dot" />
    {label ?? STATUS_LABELS[state]}
  </span>
);

export default StatusPill;
